import { date } from 'quasar'
import columnsValues from '@/HTable/columnsValues'

export default {
  data () {
    return {
      columns: [
        {
          label: 'Номер',
          field: 'number',
          name: 'number',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Проект',
          field: 'project',
          name: 'project',
          sortable: false,
          align: 'left',
          type: 'text',
        },
        {
          label: 'Email',
          field: 'project',
          name: 'owner_email',
          sortable: false,
          align: 'left',
          type: 'text',
          format: value => {
            return value.owner ? value.owner.email : ''
          },
        },
        {
          label: 'Менеджер',
          field: 'project',
          name: 'project_manager',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: [],
          format: value => {
            return value.manager
              ? `${value.manager.first_name} ${value.manager.last_name}`
              : ''
          },
        },
        {
          label: 'Статус',
          field: 'status',
          name: 'status',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.billStatuses,
          format: val => {
            return this.formatValue(val, 'status')
          },
        },
        {
          label: 'Сумма',
          field: 'amount',
          name: 'amount',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: val => val / 100,
        },
        {
          label: 'Оплачено',
          field: 'paid_amount',
          name: 'paid_amount',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: val => val / 100,
        },
        {
          label: 'Период в счете',
          field: 'destination',
          name: 'destination',
          sortable: false,
          align: 'left',
          type: 'text',
        },
        {
          label: 'Услуга',
          field: 'service',
          name: 'service_name',
          align: 'left',
          type: 'text',
          format: val => val && val.hasOwnProperty('service')
            ? val.service.name
            : null,
        },
        {
          label: 'Способ оплаты',
          field: 'payment_method',
          name: 'payment_method',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.paymentMethods,
          format: val => {
            return this.formatValue(val, 'payment_method')
          },
        },
        {
          label: 'Комментарий',
          field: 'comment',
          name: 'comment',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value, 'DD.MM.YYYY в HH:mm')
          },
        },
        {
          label: 'Дата оплаты',
          field: 'paid_at',
          name: 'paid_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value, 'DD.MM.YYYY в HH:mm')
          },
        },
        {
          label: 'Текущий тариф',
          field: 'project',
          name: 'project_payment_plan',
          sortable: true,
          align: 'left',
          type: 'value',
          values: columnsValues.services,
          format: val => {
            return val.additional.payment_plan
          },
        },
        {
          label: 'Дата окончания тарифа',
          field: 'project',
          name: 'payment_plan_valid_until',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value.additional.payment_plan_valid_until,
              'YYYY-MM-DD')
          },
        },
        {
          label: 'Кол-во товаров',
          field: 'project',
          name: 'products_count',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: value => {
            return value.additional.products_count
          },
        },
        {
          label: 'Кол-во заказов',
          field: 'project',
          name: 'orders_count',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: value => {
            return value.additional.orders_count
          },
        },
        {
          label: 'Поставщик услуг',
          field: 'service_provider_alias',
          name: 'service_provider_id',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: [],
        },
        {
          label: 'Тип компании',
          field: 'company_type',
          name: 'company_type',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.userType.map((filter) => {
            return {
              value: `${filter.value}`,
              label: `${filter.label}`,
            }
          }),
          format: val => {
            return val !== null
              ? columnsValues.userType.find((item) => (item.value === val)).label
              : ''
          },
        },
        {
          label: 'Название компании',
          field: 'company_name',
          name: 'company_name',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'text',
          values: [],
          format: val => {
            return val ? val : 'Приватна особа'
          },
        },
        {
          label: 'Действия',
          name: 'edit',
          field: 'id',
          sortable: false,
          align: 'right',
        },
      ],
    }
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/BillsList/mixins/columns.js